import { defaultGeometryRecord, GeometryInterface } from "./Geometry";
import { PermitValue } from "./Select/Value";

export type CurbSide = "LEFT" | "RIGHT";
export interface CurbLinkRecord {
    bays_angle: string;
    bl_street_name: string;
    bays_count: number;
    id: number;
    location_info: string | null;
    regulation_id: number;
    segment_id: string;
    shst_location_end: string | null;
    shst_location_start: string | null;
    side: string | null;
    street_name: string | null;
    geometry: GeometryInterface;
    uniqueId: string;
    isHiddenInCreateNewRegulationPanel: boolean;
    from_node: number | null;
    to_node: number | null;
    curb_side: CurbSide | null;
    isCustomSegmentOnCustomSegment: boolean;
    permits?: Array<PermitValue>;
    length?: number;
    has_demand_data?: boolean;
    width?: number;
}

export const defaultCurbLinkRecord = {
    bays_angle: "",
    bl_street_name: "",
    bays_count: 0,
    id: 0,
    location_info: null,
    regulation_id: 0,
    segment_id: "",
    shst_location_end: null,
    shst_location_start: null,
    side: null,
    street_name: null,
    geometry: defaultGeometryRecord,
    uniqueId: "",
    isHiddenInCreateNewRegulationPanel: false,
    isCustomSegmentOnCustomSegment: false,
    from_node: null,
    to_node: null,
    curb_side: null
};

export interface RegulationLinkRecord {
    regulation_id: number;
    curb_link_id?: number;
    custom_link_id?: number;
}
